import { BaseControlOption } from '../control-options/control-option.interface';
import { BaseControl } from './base-control.model';
import { ViewRowControl } from './view-row-control.model';

export class UiGroupControl extends BaseControl {

  name: string;
  rows: ViewRowControl[] = [];

  constructor(id: string, label: string) {
    super(id, label, new Array<BaseControlOption>);
    this.className = "UiGroupControl";
    this.name = label;
  }

}
